// extracted by mini-css-extract-plugin
export default {"image-wrapper":"ProfileImgBtn_image-wrapper__jzxt-","avatar":"ProfileImgBtn_avatar__1kgwC","btn":"ProfileImgBtn_btn__1Hndu","i":"ProfileImgBtn_i__Hvrq8"};